import { render, staticRenderFns } from "./admin-complete.vue?vue&type=template&id=22cdcd3e&"
import script from "./admin-complete.vue?vue&type=script&lang=js&"
export * from "./admin-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports